import GxButton from "../../components/common/actions/buttons/GxButton";

interface DrawerFooterProps {
  handleClose: () => void;
  handledrawerSubmit: () => void;
  cancel?: string;
  submit?: string;
  title?: string;
  subtitle?: string;
  openDrawer?: boolean;
  onClose?: () => void;
}

const DrawerFooter: React.FC<DrawerFooterProps> = ({
  handleClose,
  handledrawerSubmit,
  cancel,
  submit,
}) => (
  <div className="gx-drawer-footer">
    <div className="gx-drawer-row">
      {cancel && (
        <GxButton variant="outlined" width="small" onClick={handleClose}>
          {cancel}
        </GxButton>
      )}

      {submit && (
        <GxButton variant="filled" onClick={handledrawerSubmit} width="small">
          {submit}
        </GxButton>
      )}
    </div>
  </div>
);

export default DrawerFooter;
